import { Component, OnInit } from '@angular/core';
import { LevelOfServiceService } from '../service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-level-of-service',
  templateUrl: './level-of-service-list.component.html',
  styleUrls: ['./level-of-service-list.component.css']
})
export class LevelOfServiceComponent implements OnInit {
  search;
  levelOfServices =[];
  user;
  status="active"

  constructor(
    private levelOfServiceService: LevelOfServiceService,
  ) { }

  ngOnInit() {
    this.getLevelOfService();
  }

  onChangeStatus(evt) {
    this.getLevelOfService();
  }

  getLevelOfService() {
      const queryParams = {
        status: this.status
      }

      this.levelOfServiceService
        .getLevelOfServices(queryParams)
        .subscribe(data => {
          if (data && data.length) {
            this.levelOfServices = data;
          }else{
            this.levelOfServices = [];
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
  }
  
  ngOnDestroy(): void {
  }
}
